import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "file-arae" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Search ")
const _hoisted_3 = { style: {"float":"left"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { style: {"float":"left"} }
const _hoisted_6 = { style: {"float":"right"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { style: {"float":"right"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("clear")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("save")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("send")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("login")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"400px"} }, "Address"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"550px"} }, "PeerId"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px"} }, "Chat")
], -1)
const _hoisted_15 = { style: {"width":"400px"} }
const _hoisted_16 = { style: {"width":"550px"} }
const _hoisted_17 = { style: {"width":"50px"} }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"400px"} }, "From"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"350px"} }, "Message"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"150px"} }, "Timestamp"),
  /*#__PURE__*/_createElementVNode("th", { style: {"width":"50px"} }, "Chat")
], -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { style: {"width":"400px"} }
const _hoisted_22 = { style: {"width":"350px"} }
const _hoisted_23 = { style: {"width":"150px"} }
const _hoisted_24 = { style: {"width":"50px"} }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Prev ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Next ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Clean ")

import { ref } from 'vue'

import { GreenChat } from "../libs/greenchat"
import * as tools from "../libs/tools"
import { connected, connectState } from "../libs/connect"
import * as constant from "../constant"
import * as element from "../libs/element"
import * as storage from '../libs/storage'
import { checkOnline, sendMessage} from '../libs/fluence'


const __default__ = {
  name: 'ChatsPage',
  props: {
  }
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const greenchat = new GreenChat();

const userAddr = connectState.userAddr;
const showChatShowVisiable = ref(false);
const searchAddress = ref('');

const chatOnline = ref(false);
const chatToAddress = ref('');
const chatToPeerId = ref('');
const chatToMessage = ref('');

const chatToNewMessages = connectState.fluenceChatNewMessages;
const chatToMessageList = connectState.fluenceChatMessages;

const activeName = connectState.activeName;
const loadDrawerStatus = ref(false);
const loadStatus = ref(false);

const greenChatList = ref(new Array());
const hasMore = ref(false);
const pageSize = ref(6);
const pageCount = ref(0);

const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `;

//address explore url
const addressExplorerUrl = (address:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return `${blockExplorerUrls}/address/${address}`
    }
  }
  return address;
}

//transaction explore url
const transactionExplorerUrl = (transaction:string) => {
  for(const i in constant.chainList){
    if(connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return blockExplorerUrls + '/tx/' + transaction;
    }
  }
  return transaction;
}

//on click to copy address
const onClickToCopy = async (content:string) => {
  tools.clickToCopy(content);
  
  element.elMessage('success', 'Copy ' + content + ' to clipboard success.');     
};

//on click to chat with someone
const changeChatAddress = async (address:string, peerId:string = '') => {
  address = address.trim();
  peerId = peerId.trim();

  const fluenceId = await greenchat.getPeerId(connectState.userAddr.value);

  if(peerId === ''){
    peerId = await greenchat.getPeerId(address);
  }

  chatToAddress.value = address;
  chatToPeerId.value = peerId;

  showChatShowVisiable.value = true;

  if(fluenceId === '' || fluenceId != connectState.fluenceId){
    chatOnline.value = false;
    onLoginChat();
  }else{
    loadDrawerStatus.value = true;
    await onCheckUserOnline();
    loadDrawerStatus.value = false;
  }
  
}

//on click to login chat
const onLoginChat = async () => {
  try{
    loadDrawerStatus.value = true;

    const tx = await greenchat.updatePeerId();

    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;

    await onCheckUserOnline();

    chatOnline.value = true;
  }catch(e){
    element.alertMessage(e);
  }finally{
    loadDrawerStatus.value = false;
  }
}

//check user online or not
const onCheckUserOnline = async () => {
  try{

    checkOnline(chatToPeerId.value);

    for(let i = 0; i < 100; i++){
      await tools.sleep(100);
      if(connectState.fluenceOnline[chatToPeerId.value] === true){
        break;
      }
    }

    if(connectState.fluenceOnline[chatToPeerId.value] === false){
      element.alertMessage("target user is not online now!");
    }else{
      element.elMessage('success', 'login success, you can chat with the user now!', true);
    }    

  }catch(e){
    element.alertMessage("target user is not online now!");
  }

}

//on click to send message
const onSendChatMessage = async () => {
  
  if(connectState.fluenceOnline[chatToPeerId.value] === false){
    element.alertMessage("target user is not online now!");
    return;
  }

  chatToMessage.value = chatToMessage.value.trim();
  if(chatToMessage.value.length < 3){
    element.alertMessage("invalid !");
    return;
  }

  const timestamp = (new Date()).getTime();

  chatToMessageList.value.push({
    from: userAddr.value.toLowerCase(),
    to: chatToAddress.value.toLowerCase(),
    msg: chatToMessage.value,
    timestamp: timestamp,
    peer: false,
  });

  const res = await sendMessage(chatToPeerId.value, userAddr.value, chatToMessage.value, String(timestamp));

  //reset chat message
  chatToMessage.value = '';
}

//when chat drawer open
const onChatDrawerOpen = async () => {
  const chatlink = await greenchat.getChatHistory(chatToAddress.value);
  const chatList = new Array();

  for(const i in chatToMessageList.value){
    if(chatToMessageList.value[i].from === userAddr.value.toLowerCase() ||
      chatToMessageList.value[i].to === userAddr.value.toLowerCase()){

      chatList.push(chatToMessageList.value[i]);
    }
  }

  if(chatList.length === 0 && chatlink != ''){
    let res = await fetch(chatlink, {
      "referrer": (window as any).location.href,
      "referrerPolicy": "no-referrer-when-downgrade",
      "method": "GET",
      "credentials": "omit",
      "redirect": "follow",
    });
  
    if (res.status >= 200 && res.status <= 299){
      res = await res.json();

      for(const i in res){
        try{
          if(res[i].from === userAddr.value.toLowerCase() || res[i].to === userAddr.value.toLowerCase()){
            chatToMessageList.value.push(res[i]);
          }
        }catch(e){
          continue;
        }
      }
    }
  }
}

//click to clean new messages
const onCleanNewMessages = async () => {
  searchAddress.value = '';
  chatToMessageList.value = new Array();
}

//click to clean chat history
const onClearChatHistory = async () => {
  const chatList = new Array();
  for(const i in chatToMessageList.value){
    if(chatToMessageList.value[i].from != userAddr.value.toLowerCase() &&
      chatToMessageList.value[i].to != userAddr.value.toLowerCase()){

      chatList.push(chatToMessageList.value[i]);
    }
  }

  chatToMessageList.value = chatList;

  try{
    loadDrawerStatus.value = true;
    const tx = await greenchat.updateChatHistory(chatToAddress.value, '');
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Clear chat success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);       

  }catch(e){
    element.alertMessage(e);
  }finally{
    loadDrawerStatus.value = false;
  }
}

//click to save chat history
const onSaveChatHistory = async () => {
  const chatList = new Array();
  for(const i in chatToMessageList.value){
    if(chatToMessageList.value[i].from === userAddr.value.toLowerCase() ||
      chatToMessageList.value[i].to === userAddr.value.toLowerCase()){
      chatList.push(chatToMessageList.value[i]);
    }
  }

  if(chatList.length === 0){
    try{
      loadDrawerStatus.value = true;
      const tx = await greenchat.updateChatHistory(chatToAddress.value, '');
      connectState.transactions.value.unshift(tx);
      connectState.transactionCount.value++;
      const msg = `<div><span>Save chat success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
      element.elMessage('success', msg, true);
    }catch(e){
      element.alertMessage(e);
    }finally{
      loadDrawerStatus.value = false;
    }

    return; 
  }

  const name = userAddr.value.toLowerCase() + chatToAddress.value.toLowerCase();
  const content = JSON.stringify(chatList);
  const contentType = 'application/json';

  const file = tools.makeFileObject(name, contentType, content);

  const reference = await storage.uploadFile(file);

  if(reference === ''){
    element.alertMessage('save chat history failed!');
    return;
  }

  try{
    loadDrawerStatus.value = true;
    const tx = await greenchat.updateChatHistory(chatToAddress.value, reference);
    connectState.transactions.value.unshift(tx);
    connectState.transactionCount.value++;
    const msg = `<div><span>Save chat success! Transaction: </span><a href="${transactionExplorerUrl(tx)}" target="_blank">${tx}</a></div>`;
    element.elMessage('success', msg, true);
  }catch(e){
    element.alertMessage(e);
  }finally{
    loadDrawerStatus.value = false;
  }
}

//get green chat infos by page size and page count
const getGreenChatCount = async (address:string) => {
  const infoList = new Array();

  address = address.trim();

  if(address != ''){
    const peerId = await greenchat.getPeerId(address);
    infoList.push({
      address: address,
      peerId: peerId,
    });
  }else{
    const res = await greenchat.getPeerList(pageSize.value, pageCount.value);

    if(res.length < pageSize.value){
      hasMore.value = false;
    }else{
      hasMore.value = true;
    }

    for(const i in res){
      if(res[i].isOwner || res[i].isOffline){
        continue;
      }

      infoList.push(res[i]);
    }
  }

  greenChatList.value = infoList;
}

//on click for prev page
const onHandlePrev = async () => {
  if(pageCount.value > 0){
    pageCount.value--;
  }
  handleClick();
}

//on click for next page
const onHandleNext = async () => {
  if(hasMore.value){
    pageCount.value++;
  }
  handleClick();
}

//handle page refresh
const handleClick = async () => {
  //wait for the active name change
  await tools.sleep(100);

  connectState.activeName.value = activeName.value;
  tools.setUrlParamter('activeName', activeName.value);

  try{
    loadStatus.value = true;
    if (!(await connected())){
      greenChatList.value = new Array();
      return;
    }

    if(pageCount.value < 0){
      pageCount.value = 0;
    }

    if(activeName.value === 'chat'){
      await getGreenChatCount(searchAddress.value);
    }

  }catch(e){
    greenChatList.value = new Array();
  }finally{
    loadStatus.value = false;
  }
}

//clean search content and bind search callback function
connectState.search = '';
connectState.searchCallback = handleClick;
//try get activeName from the url paramter
try{
  activeName.value = tools.getUrlParamter('activeName');
  if(activeName.value != 'chat' &&
    activeName.value != 'message'){

    activeName.value = 'chat';
  }
}catch(e){
  activeName.value = 'chat';
}

//update page size
handleClick();  

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ChatLineSquare = _resolveComponent("ChatLineSquare")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"background-color":"#ffffff"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tabs, {
              modelValue: _unref(activeName),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : null)),
              class: "file-tabs",
              onTabClick: handleClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: "Chat",
                  name: "chat"
                }),
                _createVNode(_component_el_tab_pane, {
                  label: "Message",
                  name: "message"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              modelValue: searchAddress.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchAddress).value = $event)),
              placeholder: _unref(userAddr),
              size: "small",
              style: {"width":"350px"}
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: handleClick
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_drawer, {
              modelValue: showChatShowVisiable.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showChatShowVisiable).value = $event)),
              direction: "rtl",
              "destroy-on-close": "",
              onOpened: onChatDrawerOpen
            }, {
              header: _withCtx(() => [
                _createElementVNode("h4", null, "Chat With: " + _toDisplayString(chatToAddress.value), 1)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatToMessageList), (info) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: info.timestamp
                  }, [
                    (info.peer === true && info.from === chatToAddress.value.toLowerCase() && info.to === _unref(userAddr).toLowerCase())
                      ? (_openBlock(), _createBlock(_component_el_card, {
                          key: 0,
                          class: "box-card",
                          style: {"float":"left","width":"200px","color":"#409EFF"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_3, _toDisplayString((new Date(info.timestamp)).toLocaleString()), 1),
                            _hoisted_4,
                            _createElementVNode("span", _hoisted_5, _toDisplayString(info.msg), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (info.peer === false && info.from === _unref(userAddr).toLowerCase() && info.to === chatToAddress.value.toLowerCase())
                      ? (_openBlock(), _createBlock(_component_el_card, {
                          key: 1,
                          class: "box-card",
                          style: {"float":"right","width":"200px","color":"#67C23A"}
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_6, _toDisplayString((new Date(info.timestamp)).toLocaleString()), 1),
                            _hoisted_7,
                            _createElementVNode("span", _hoisted_8, _toDisplayString(info.msg), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              footer: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  style: {"flex":"auto"},
                  "element-loading-text": "Checking...",
                  "element-loading-spinner": svg,
                  "element-loading-svg-view-box": "-10, -10, 50, 50",
                  "element-loading-background": "#ffffff"
                }, [
                  _createVNode(_component_el_input, {
                    modelValue: chatToMessage.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((chatToMessage).value = $event)),
                    placeholder: "hello!",
                    type: "textarea",
                    style: {"float":"right","margin-bottom":"5px"},
                    rows: "3"
                  }, null, 8, ["modelValue"]),
                  (chatOnline.value === true)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        onClick: onClearChatHistory
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (chatOnline.value === true)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        onClick: onSaveChatHistory
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (chatOnline.value === true)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "primary",
                        onClick: onSendChatMessage
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (chatOnline.value === false)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 3,
                        type: "primary",
                        onClick: onLoginChat
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_loading, loadDrawerStatus.value]
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_main, {
          style: {"height":"450px","margin-top":"20px"},
          "element-loading-text": "Loading...",
          "element-loading-spinner": svg,
          "element-loading-svg-view-box": "-10, -10, 50, 50",
          "element-loading-background": "#ffffff"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                (_unref(activeName) === 'chat')
                  ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(greenChatList.value, (info) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: info.address
                          }, [
                            _createElementVNode("td", _hoisted_15, [
                              _createVNode(_component_el_link, {
                                type: "success",
                                target: "_blank",
                                href: addressExplorerUrl(info.address)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(info.address), 1)
                                ]),
                                _: 2
                              }, 1032, ["href"]),
                              _createVNode(_component_el_icon, {
                                onClick: ($event: any) => (onClickToCopy(info.address))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_document_copy)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _createElementVNode("td", _hoisted_16, [
                              _createTextVNode(_toDisplayString(info.peerId) + " ", 1),
                              _createVNode(_component_el_icon, {
                                onClick: ($event: any) => (onClickToCopy(info.peerId))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_document_copy)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _createElementVNode("td", _hoisted_17, [
                              _createVNode(_component_el_icon, {
                                onClick: ($event: any) => (changeChatAddress(info.address, info.peerId))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ChatLineSquare)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(activeName) === 'message')
                  ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatToNewMessages), (info) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: info.from
                          }, [
                            (info.to===_unref(userAddr).toLowerCase()&&(searchAddress.value===''||searchAddress.value===info.from))
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                                  _createElementVNode("td", _hoisted_21, [
                                    _createVNode(_component_el_link, {
                                      type: "success",
                                      target: "_blank",
                                      href: addressExplorerUrl(info.from)
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(info.from), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["href"]),
                                    _createVNode(_component_el_icon, {
                                      onClick: ($event: any) => (onClickToCopy(info.from))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_document_copy)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _createElementVNode("td", _hoisted_22, [
                                    _createTextVNode(_toDisplayString(info.msg) + " ", 1),
                                    _createVNode(_component_el_icon, {
                                      onClick: ($event: any) => (onClickToCopy(info.msg))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_document_copy)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _createElementVNode("td", _hoisted_23, _toDisplayString((new Date(info.timestamp)).toLocaleString()), 1),
                                  _createElementVNode("td", _hoisted_24, [
                                    _createVNode(_component_el_icon, {
                                      onClick: ($event: any) => (changeChatAddress(info.from))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ChatLineSquare)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_loading, loadStatus.value]
        ]),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_unref(activeName)==='chat')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    style: {"margin-top":"10px"},
                    onClick: onHandlePrev
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(activeName)==='chat')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    style: {"margin-top":"10px"},
                    onClick: onHandleNext,
                    disabled: !hasMore.value
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (_unref(activeName)==='message')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    type: "primary",
                    style: {"margin-top":"10px"},
                    onClick: onCleanNewMessages
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})